module.exports = __webpack_public_path__ + "img/zhabagin_500.43e21dae.jpg";